import { gql } from '@apollo/client';

export const UPDATE_MESSAGES_LAST_READ = gql`
  mutation UpdateMessagesLastRead($input: UpdateMessagesLastReadInput!) {
    updateMessagesLastRead(input: $input) {
      fantasyLeagueMember {
        id
        messagesLastReadAt
        unreadMessagesCount
        unreadEventsCount
        unreadActivityCount
      }
      errors
    }
  }
`;
